export default "__VITE_ASSET__d0f853bc__"